import filter from 'ramda/src/filter'
import propEq from 'ramda/src/propEq'
import { TWITCH_PANEL_EXTENSION_ID } from 'root/extensions/extensionsIds'

export default (extensions) => {
	const filteredExtensions = filter(propEq('id', TWITCH_PANEL_EXTENSION_ID), extensions)
	return filteredExtensions.length > 0
}
